import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { SectiuniService } from '../sectiuni.service';
import { ISectiuneAddPayload } from '../sectiuni.interface';

@Component({
  selector: 'app-add-sectiune',
  templateUrl: './add-sectiune.component.html',
  styleUrls: ['./add-sectiune.component.scss'],
})
export class AddSectiuneComponent {
  // general error
  errorTitle: string = environment.config.customNotifications.headers.error;
  errorIcon: string = environment.config.customNotifications.icons.error;
  errorType: string = environment.config.customNotifications.icons.error;

  token!: string;
  isLoading = false;
  form: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    slug: new FormControl('', [Validators.required]),
    observations: new FormControl('', []),
  });

  constructor(
    private dialogRef: MatDialogRef<AddSectiuneComponent>,
    private sectiuniService: SectiuniService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.processToken();
  }

  closeDialog() {
    this.dialogRef?.close({
      success: false,
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.sectiuniService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const newSectiune: ISectiuneAddPayload = {
      name: this.form.get('name')?.value,
      slug: this.form.get('slug')?.value,
      observations: this.form.get('observations')?.value,
    };

    this.sectiuniService
      .addSection(newSectiune)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res) => {
          this.dialogRef.close({ success: true });
        },
        error: (err) => {
          let errorMessage =
            environment.config.customNotifications.generalMessages.error;
          this.notificationService.warningSwal(
            this.errorTitle,
            errorMessage,
            this.errorIcon
          );
        },
      });
  }
}
